import { useEffect, useState } from "react";
import cogoToast from "cogo-toast-react-17-fix";
import { useNavigate } from "react-router-dom";
import RightContent1 from "../../components/OnBoard/login_right";
import styles from "./Login.module.css";
import OtpInputs from "../../Utils/OtpInputs";
import { BASE_URL, GET_MFA, MFA_VERIFY } from "../../Utils/constant";
import { resetTimer, Timer } from "../../Utils/helper";
import { useSelector, useDispatch } from "react-redux";
import { updateUser } from "../../Utils/Redux/UserSlice";
import API from "../../ApiConfig";

const Mfa = () => {
  const [mfaOtp, setMfaOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const User = useSelector((state) => state.User);
  const [OTPkey, setOTPKey] = useState(Date.now())
  const [resetOtp, setResetOtp] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const GetMfaOtp = (data) => {
    setMfaOtp(data);
  };

  const getOTP = () => {
    let formData = { user_id: User.user_id };
    API.post(GET_MFA, formData)
      .then((data) => {
        let res = data.data;
        if (res.success == true) {
          cogoToast.success("OTP re-sent to " + User.masked_email);
          setOTPKey(Date.now())
          setResetOtp(prev=>!prev)
          setMfaOtp("")
        }
      })
      .catch((err) => {
        cogoToast.error(err.response.data.message);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true); // Set loading state to true
    let formData = { identifier: User.email, otp: mfaOtp };
    API.post(MFA_VERIFY, formData)
      .then((data) => {
        let res = data.data;
        if (res.data) {
          resetTimer();
          // if(res.data.is_first_login){
          //   dispatch(
          //     updateUser({
          //       access_token: res.data.access_token,

          //       refresh_token: res.data.refresh_token,
          //       expiry_time: res.data.expiry_time,
          //       company_id:res.data.company_id,
          //       internal_user:res.data.internal_user,
          //       user_role_name:res.data.user_role_name,
          //       wallet_active:res.data.wallet_active
          //     })
          //   )
          //   navigate("/app/termandPolicy")
          // }
            dispatch(
              updateUser({
                access_token: res.data.access_token,
                refresh_token: res.data.refresh_token,
                expiry_time: res.data.expiry_time,
                user_name: User.email,
                company_id:res.data.company_id,
                internal_user:res.data.internal_user,
                user_role_name:res.data.user_role_name,
                wallet_active:res.data.wallet_active
              })
  
            )
          navigate("/dashboard");
          // window.document.location = "/dashboard"
        } else {
          cogoToast.error("Incorrect OTP. Please check again or resend OTP");
        }
      })
      .catch((err) => {
        cogoToast.error(err.response.data.detail);
      })
      .finally(() => {
        setLoading(false); // Set loading state to false after API response
      });
  };

  return (
    <div className={styles.login}>
      <div className={styles.leftContentParent}>
        <form className={styles.mfaForm} onSubmit={handleSubmit}>
          <div className={styles.leftContent}>
            <h1>Verify your email</h1>
            <h2>Please enter OTP sent to {User.masked_email}</h2>
            <OtpInputs getOtp={GetMfaOtp} resetTrigger={resetOtp} />
            <div style={{ width: "23rem" }}>
              <Timer m={User.otp_expires_in || 0.5} getOTP={getOTP} key={OTPkey} />
              <div className={styles.buttonHelperText}>
                <button
                  type="submit"
                  className={mfaOtp ? "primaryBtn" : "DisableprimaryBtn"}
                  disabled={!mfaOtp || loading} // Disable button during loading
                >
                  <div className={styles.copyrightText}>
                    {loading ? "Verifying..." : "Verify"} {/* Conditional button text */}
                  </div>
                </button>
              </div>
            </div>
          </div>
        </form>
        <div className={styles.footer}>
          <div className={styles.container}>
            <div className={styles.copyright}>
            Copyright 2026 AuthBridge, All Rights Reserved.
            </div>
          </div>
        </div>
      </div>
      <RightContent1 />
    </div>
  );
};

export default Mfa;
